import {CommonStatus} from "@/enums/status";

export class CustomerParams {
    page? = 1;
    limit? = 20;
    search?: string;
    status? = CommonStatus.Active;
    type?: number;
    onlyParent?: number;
}

export class InsuranceFeeParams {
    priceMark?: number;
    freightBelowByPercent?: number;
    freightAboveByPercent?: number;
}
